// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
@keyframes show {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes expand {
  0% {
    transform: scaleX(0.1) scaleY(0.1);
  }
  30% {
    transform: scaleX(0.5) scaleY(0.1);
  }
  40% {
    transform: scaleX(1) scaleY(0.1);
  }
  60% {
    transform: scaleX(1) scaleY(0.1);
  }
  75% {
    transform: scaleX(1) scaleY(0.1);
  }
  100% {
    transform: scaleX(1) scaleY(1);
  }
}
.shark .animation.animation-type-expand .content-animation {
  transform-origin: top;
  animation: expand 1s ease-in-out;
}
.shark .animation.animation-type-show .content-animation {
  transform-origin: top;
  animation: show 3s ease-in-out;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/Animation/animation.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,g1FAAg1F","sourcesContent":["/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n@keyframes show {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes expand {\n  0% {\n    transform: scaleX(0.1) scaleY(0.1);\n  }\n  30% {\n    transform: scaleX(0.5) scaleY(0.1);\n  }\n  40% {\n    transform: scaleX(1) scaleY(0.1);\n  }\n  60% {\n    transform: scaleX(1) scaleY(0.1);\n  }\n  75% {\n    transform: scaleX(1) scaleY(0.1);\n  }\n  100% {\n    transform: scaleX(1) scaleY(1);\n  }\n}\n.shark .animation.animation-type-expand .content-animation {\n  transform-origin: top;\n  animation: expand 1s ease-in-out;\n}\n.shark .animation.animation-type-show .content-animation {\n  transform-origin: top;\n  animation: show 3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
